import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, useTheme } from '@mui/material';

function HelpTextField({
  value,
  onChange,
  label,
  type,
  name,
  required,
  StartIcon,
  multiline,
  height,
}) {
  const hasIcon = Boolean(StartIcon);
  const theme = useTheme();
  return (
    <TextField
      multiline={multiline}
      value={value}
      onChange={onChange}
      inputProps={{
        style: {
          alignItems: 'baseline',
          marginLeft: 5,
          height: multiline ? height : '0.5rem',
        },
      }}
      // eslint-disable-next-line
      InputProps={hasIcon ? {
        startAdornment: (
          <InputAdornment position="start">
            <StartIcon />
          </InputAdornment>
        ),
        sx: { alignItems: 'baseline' },
      } : {}}
      InputLabelProps={{
        shrink: false,
        disabled: true,
        sx: {
          marginLeft: hasIcon ? 5 : 0.5,
          marginTop: multiline ? 0 : '-0.5rem',
          fontSize: { xs: '1rem', ipad: '0.9rem' },
        },
      }}
      label={value === '' ? label : ''}
      type={type}
      name={name}
      required={required}
      fullWidth
      sx={{
        backgroundColor: theme.palette.neutral.A200,
        borderRadius: '0.5rem',
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderRadius: '0.5rem',
            borderColor: theme.palette.neutral.A200,
          },
          '&:hover fieldset': {
            borderColor: 'transparent',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'transparent',
          },
        },
      }}
    />
  );
}

HelpTextField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  StartIcon: PropTypes.func,
  multiline: PropTypes.bool,
  height: PropTypes.string,
};

HelpTextField.defaultProps = {
  StartIcon: null,
  required: false,
  multiline: false,
  height: '3rem',
};

export default HelpTextField;
